import { getUnknownErrorMessage } from '@caresend/utils';
import { getRouter, getRoute } from '../../../../router/helpers/initRouter.js';
import { getStore } from '../../../helpers/initStore.js';

const sliceConfirmVisitErrorMessage = (errorMessage) => {
    const SCHEDULE_DRAFT_WAYPOINT_ERROR_PREFIX = '[ScheduleDraftWaypointVisit]';
    const indexOfPrefix = errorMessage
        .indexOf(SCHEDULE_DRAFT_WAYPOINT_ERROR_PREFIX);
    if (indexOfPrefix === -1)
        return null;
    return errorMessage
        .slice(indexOfPrefix + SCHEDULE_DRAFT_WAYPOINT_ERROR_PREFIX.length)
        .trim();
};
const navToNextStepOrExit = () => {
    const store = getStore();
    const router = getRouter();
    const route = getRoute();
    const nextStepRoute = store.getters['schedulingFlow/getNextStepRouteInOrder'](route.value);
    if (nextStepRoute) {
        router.replace(nextStepRoute);
        return;
    }
    store.dispatch('schedulingFlow/maybeRouteToExitRoute');
};
/**
 * This function is used to confirm the visit. This is defined here because the
 * logic is used for the `SchedulingFlowCheckout` and `SchedulingPayment`
 * components and the checkout's completion action. See
 * `.../schedulingFlow/routes.ts` for more details on why.
 */
const confirmVisit = async () => {
    const store = getStore();
    let result;
    try {
        await store.dispatch('schedulingFlow/confirmVisit');
        result = { success: true };
    }
    catch (error) {
        const unknownErrorMessage = getUnknownErrorMessage(error);
        const slicedErrorMessage = sliceConfirmVisitErrorMessage(unknownErrorMessage);
        let errorMessage;
        if (slicedErrorMessage) {
            /** We have a double booking attempt in this situation */
            errorMessage = slicedErrorMessage;
            store.commit('schedulingFlow/CLEAR_TIME_SLOTS_ONLY');
        }
        else {
            errorMessage = `Visit could not be scheduled. ${unknownErrorMessage}`;
        }
        result = { success: false, errorMessage };
        throw error;
    }
    return result;
};

export { confirmVisit, navToNextStepOrExit };
